var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { action: _vm.formAction, method: "post" },
      on: { submit: _vm.validate },
    },
    [
      _vm._t("csrf-token"),
      _vm._v(" "),
      _vm._t("input-next"),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col" }, [
          _c("label", { class: _vm.emailError ? "error-anchor" : "" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.emailLabel) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "form-control",
            class: _vm.emailError ? "is-invalid error-anchor" : "",
            attrs: {
              name: "email",
              type: "email",
              placeholder: _vm.emailLabel,
            },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.emailError
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.emailError) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "form-group col" },
          [
            _vm.showTurnstile
              ? _c("turnstile", {
                  class: !_vm.isRecaptchaFilled
                    ? "border-error error-anchor"
                    : "",
                  attrs: {
                    sitekey: _vm.newCaptchaSiteKey,
                    language: _vm.language,
                  },
                })
              : _vm.showHcaptcha
              ? _c("hcaptcha", {
                  class: !_vm.isRecaptchaFilled
                    ? "border-error error-anchor"
                    : "",
                  attrs: {
                    sitekey: _vm.newCaptchaSiteKey,
                    language: _vm.language,
                  },
                })
              : _c("recaptcha", {
                  class: !_vm.isRecaptchaFilled
                    ? "border-error error-anchor"
                    : "",
                  attrs: {
                    sitekey: _vm.recaptchaPublicKey,
                    language: _vm.language,
                  },
                }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ui-button", {
        attrs: {
          type: "submit",
          appearance: "primary",
          disabled:
            !_vm.isRecaptchaFilled || !_vm.isEmailValid || _vm.submittedForm,
          label: _vm.btnLabel,
          block: "",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }